import { render } from "./NeobuqHomeView.vue?vue&type=template&id=0c91c47c&scoped=true"
import script from "./NeobuqHomeView.vue?vue&type=script&lang=js"
export * from "./NeobuqHomeView.vue?vue&type=script&lang=js"

import "./NeobuqHomeView.vue?vue&type=style&index=0&id=0c91c47c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c91c47c"]])

export default __exports__